// Import polyfill from node_modules
// import 'core-js/modules/es6.set.js'
// import 'core-js/modules/es6.array.find-index.js'


$(document).ready(function () {
	// 選擇商品區塊增加
	var selectCount = 1;
	// 更新商品数量
	function updateProductCount() {
	  var productCount = $('.bncont-form_select.comm').length;
	  $('#productCount').text(productCount);
	}
	// 更新商品小計
	function updateTotalPrice() {
		// ajax透過已選商品&規格&加購商品計算商品小計(後端給動態結果)
	var productElements = document.getElementsByName('product_arr');
		var productValues = [];
		for (var i = 0; i < productElements.length; i++) {
		  var value = productElements[i].value;
		  productValues.push(value);
		}
		// ['1', '2', '3', '4', '5']
		var specElements = document.getElementsByName('spec_arr');
		var specValues = [];
		for (var i = 0; i < specElements.length; i++) {
		  var value = specElements[i].value;
		  specValues.push(value);
		}
		// ['1', '2', '3', '4', '5']
		var add_productElements = document.getElementsByName('add_product_arr');
		var add_productValues = [];
		for (var i = 0; i < add_productElements.length; i++) {
		  var value = add_productElements[i].value;
		  add_productValues.push(value);
		}
		// ['不加購']
		$('#sumPrice').text('後端計算給結果');
	}
	// 新增商品按钮點擊事件
	$('#addSelectBtn').on('click', function () {
		// 複製最後一個選擇框群組
		var clonedSelectGroup = $('.bncont-form_select.comm').last().clone();
		// 更新群組數量
		selectCount++;
		// 設置新的選擇框ID
		clonedSelectGroup.find('.cho-comm select').attr({'id':'CommSelectProduct'+selectCount});
		clonedSelectGroup.find('.cho-size select').attr({'id':'CommSelectSpec'+selectCount});
		clonedSelectGroup.find('.cho-size select').attr({'id':'OtherCommSelectSpec'+selectCount});
		// 加入複製的群組
		clonedSelectGroup.insertAfter($('.bncont-form_select.comm').last());
		// 更新規格選項名稱(清空及後端給動態結果)
		$('.cho-size #CommSelectSpec_'+selectCount).empty().append('<option value="">商品1動態規格</option>');
		$('.cho-size #OtherCommSelectSpec_'+selectCount).empty().append('<option value="">現貨商品1動態規格</option>');
		updateProductCount();
		if($('.bncont-form_select.comm').length == 5) {
			$(this).addClass('opa');
		}
	});
	// 删除按钮點擊事件
	$(document).on('click', '.cho-delete', function () {
	  var selectGroup = $(this).closest('.bncont-form_select.comm');
	  if($('.bncont-form_select.comm').length > 1) {
		selectGroup.remove();
		updateProductCount();
		updateTotalPrice();
	  }
	  if($('.bncont-form_select.comm').length < 5) {
		$('.bncont-form_btn').removeClass('opa');
	  }
	});
	// 選擇商品更新對應規格內容
	$(document).on('change', '.bncont-form_select .cho-comm select.csize', function() {
		var product_id = $(this).val();
		var change_size_select = $(this).parents('.cho-comm').parents('.bncont-form_select').children('.cho-size').children('select');
		change_size_select.empty().append('<option value="">商品規格</option>');
		if(product_id != ''){
			// ajax透過商品id取的對應規格名稱及規格內容(後端給動態結果)
			var response = JSON.parse('{"spec_title":"商品'+product_id+'動態規格","spec_arr":[{"id":"1","name":"XS"},{"id":"2","name":"S"},{"id":"3","name":"M"},{"id":"4","name":"L"},{"id":"5","name":"XL"}]}');
			change_size_select.empty().append('<option value="">'+response.spec_title+'</option>');
			response.spec_arr.forEach(function(spec) {
				change_size_select.append('<option value="'+spec.id+'">'+spec.name+'</option>');
			});
		}
		updateTotalPrice();
	});
	// 選擇現貨商品更新對應規格內容
	$(document).on('change', '.bncont-form_select .cho-comm select.cnbr', function() {
		var product_id = $(this).val();
		var change_size_select = $(this).parents('.cho-comm').parents('.bncont-form_select').children('.cho-size').children('select');
		change_size_select.empty().append('<option value="">商品規格</option>');
		if(product_id != ''){
			// ajax透過商品id取的對應規格名稱及規格內容(後端給動態結果)
			var response = JSON.parse('{"spec_title":"商品'+product_id+'動態規格","spec_arr":[{"id":"1","name":"1份"},{"id":"2","name":"2份"},{"id":"3","name":"3份"},{"id":"4","name":"4份"},{"id":"5","name":"5份"}]}');
			change_size_select.empty().append('<option value="">'+response.spec_title+'</option>');
			response.spec_arr.forEach(function(spec) {
				change_size_select.append('<option value="'+spec.id+'">'+spec.name+'</option>');
			});
		}
		updateTotalPrice();
	});
	// 選擇規格及加購品更新商品小計
	$(document).on('change', '.bncont-form_select .cho-size select, .bncont-form_select .cho-addcomm select', function () {
	  updateTotalPrice();
	});

	// 必填欄位判斷
	$('.nextstep').on('click', function () {
	  var hasMissingSelection = false;

	  $('.cho-size select , .cho-comm select').each(function () {
		if ($(this).val() === '') {
		  hasMissingSelection = true;
		  $(this).addClass('missing-selection');
		} else {
		  $(this).removeClass('missing-selection');
		}
	  });

	  if (hasMissingSelection) {
		return false;
	  }

	  window.location.href = 'cart.html';
	  // alert('成功!! 之後會直接前往下一頁');
	});

}); /* end document */
